import React from 'react'

import './Inline.scss'

import icon_up from '../../i/up.svg'
import icon_down from '../../i/down.svg'
import icon_clone from '../../i/clone.svg'
import icon_delete from '../../i/delete.svg'

class InlineControls extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    onClick = action => {
        const { onAction, blockId } = this.props
        onAction({ action, blockId })
    }

    render() {
        const { firstElement, lastElement, isVisible } = this.props

        return (
            <ul className={`inline-controls${isVisible ? ' is-visible' : ''}`}>
                {!firstElement ? (
                    <li onClick={() => this.onClick('up')} title="Move up">
                        <img src={icon_up} alt="" />
                    </li>
                ) : null}
                {!lastElement ? (
                    <li onClick={() => this.onClick('down')} title="Move down">
                        <img src={icon_down} alt="" />
                    </li>
                ) : null}
                <li onClick={() => this.onClick('clone')} title="Clone">
                    <img src={icon_clone} alt="" />
                </li>
                <li onClick={() => this.onClick('delete')} title="Remove">
                    <img src={icon_delete} alt="" />
                </li>
            </ul>
        )
    }
}

export default InlineControls
